
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/stuzo",
      function () {
        return require("private-next-pages/destinations/stuzo.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/stuzo"])
      });
    }
  